import { SetupDrawer } from '@Components/shared/dialogs/SetupDrawer';
import { SetupUserDrawerContent } from './SetupUserDrawerContent';
import { useDispatch } from 'react-redux';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';

export const SetupUserDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const { showUserDrawer, setShowUserDrawer } = useUserDrawer();

  return (
    <SetupDrawer
      name="SetupRound"
      open={showUserDrawer}
      onClose={() => dispatch(setShowUserDrawer(false))}
    >
      <SetupUserDrawerContent />
    </SetupDrawer>
  );
};
